export const webPlayerStorage = {
  // Token management
  getToken: () => localStorage.getItem("webPlayerToken"),
  setToken: (token) => localStorage.setItem("webPlayerToken", token),
  removeToken: () => localStorage.removeItem("webPlayerToken"),

  getLoginAuth: () => {
    const obj = localStorage.getItem("webPlayerLoginAuth");

    return JSON.parse(obj);
  },
  setLoginAuth: (obj) => {
    const safeObj = JSON.stringify(obj);

    localStorage.setItem("webPlayerLoginAuth", safeObj);
  },
  removeLoginAuth: () => localStorage.removeItem("webPlayerLoginAuth"),

  // Profile management
  getProfile: () => {
    const profile = localStorage.getItem("selectedProfile");

    return profile ? JSON.parse(profile) : {};
  },
  setProfile: (profile) =>
    localStorage.setItem("selectedProfile", JSON.stringify(profile)),
  removeProfile: () => localStorage.removeItem("selectedProfile"),

  // Profile ID management
  getProfileId: () => localStorage.getItem("selectedProfileId"),
  setProfileId: (id) => localStorage.setItem("selectedProfileId", id),
  removeProfileId: () => localStorage.removeItem("selectedProfileId"),

  // Playlist management
  getPlaylist: () => {
    const playlist = localStorage.getItem("selectedPlaylist");

    return playlist ? JSON.parse(playlist) : {};
  },
  setPlaylist: (playlist) =>
    localStorage.setItem("selectedPlaylist", JSON.stringify(playlist)),
  removePlaylist: () => localStorage.removeItem("selectedPlaylist"),

  // Auth management
  clearAll: () => {
    localStorage.removeItem("webPlayerToken");
    localStorage.removeItem("webPlayerLoginAuth");
    localStorage.removeItem("selectedProfile");
    localStorage.removeItem("selectedProfileId");
    localStorage.removeItem("selectedPlaylist");
    localStorage.removeItem("sportsPreferences");
    localStorage.removeItem("currentPlaylistId");

    localStorage.clear();
    sessionStorage.clear();
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();

      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
    });
  },
};

export default webPlayerStorage;
